import { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

interface YearChangeModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (year: string) => void;
  currentYear: string;
  patientId: string;
}

const YearChangeModal = ({
  open,
  onClose,
  onConfirm,
  currentYear,
  patientId,
}: YearChangeModalProps) => {
  const thisYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<string>(currentYear);

  const handleConfirm = () => {
    onConfirm(selectedYear);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Jahr ändern</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Jahr für Patientin <strong>{patientId}</strong> ändern:
          </Typography>
          <TextField
            select
            label="Neues Jahr"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            fullWidth
            autoFocus
          >
            {Array.from({ length: 10 }, (_, i) => thisYear - i).map((year) => (
              <MenuItem key={year} value={year.toString()}>
                {year}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          sx={{ color: "white" }}
          disabled={selectedYear === currentYear}
        >
          Jahr ändern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default YearChangeModal;
